import styled from '@emotion/styled';
import { Text } from '$shared/components/Text';
import { switchProp } from 'styled-tools';
import { breakpoints } from '~/theme';

export const StyledCounterHeader = styled(Text)<{ spacing?: 'default' | 'header' }>(
    ({ theme }) => ({
        padding: `${theme.spaces[3]} 0`,
        color: theme.colors.dark,
        whiteSpace: 'nowrap',
        [breakpoints.md]: {
            color: theme.colors.dark50,
        },
    }),
    switchProp('spacing', {
        header: ({ theme }) => ({
            padding: `0 0 0 ${theme.spaces[2]}`,
            [breakpoints.md]: {
                padding: `${theme.spaces[2]} 0`,
            },
        }),
    })
);
